import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=e034c1aa&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=e034c1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e034c1aa",
  null
  
)

export default component.exports